import React, { SVGProps, forwardRef, Ref } from 'react';

type Props = {
  title?: React.ReactNode;
  titleId?: string;
} & SVGProps<SVGSVGElement>;

function SVGEsploro({ title, titleId, ...props }: Props, svgRef?: Ref<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 39.9 34.3"
      width="72"
      height="72"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <defs>
        <style>{'.cls-1 {fill: #e2001a;}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M25.5,0c-2.4,0-4.5,1.4-5.6,3.4-1-2-3.1-3.4-5.6-3.4H0v30.5h13.8c2,0,5.2,2,5.3,3.8h1.8c.1-1.8,3.2-3.8,5.2-3.8h13.8V0h-14.4ZM6.6,1.6h4.5v6.9l-2.3-2.3-2.2,2.2V1.6ZM19.1,31.4c-1.5-1.4-3.7-2.4-5.3-2.4H1.6V1.6h3.5v10.6l3.8-3.8,3.8,3.8V1.6h1.9c2.6,0,4.7,2.1,4.7,4.8l-.2,25ZM38.4,29h-12.2c-1.6,0-3.8,1-5.3,2.4l-.1-25.1c0-2.6,2.1-4.8,4.7-4.8h12.9v27.5Z"
      />
      <rect className="cls-1" x="25.8" y="19.6" width="8" height="1.5" />
      <rect className="cls-1" x="25.8" y="13.6" width="8" height="1.5" />
      <rect className="cls-1" x="25.8" y="7.6" width="8" height="1.5" />
    </svg>
  );
}

export default forwardRef(SVGEsploro);
